import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class PersonalizedOfferService {
    static getOfferDataFromServer(currentPath, params, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('personalizedOffer'),
            'getPersonalizedOffer',
            [currentPath, params],
            additionalHeaders
        );
    }
}
